import Menu from './pages/Menu';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function App() {
  return (<> <Menu />  <ToastContainer /></>);

}

export default App;



